import { useEffect, useState } from "react";

export function useInt(data) {
  const [settingData, setSettingData] = useState({});

  useEffect(() => {
    setSettingData(toInt(data));
  }, [data]);

  return [settingData, setSettingData];
}

export function toInt(data) {
  if (!data) {
    return {};
  }

  return Object.keys(allows(data)).reduce((obj, key) => {
    obj[key] = data[key] * 1;
    return obj;
  }, {});

}

export function allows(data) {
  const {
    is_cus_batch_trans,
    is_cus_connect,
    is_cus_realtime_trans,
    is_his_batch_trans,
    is_his_connect,
    is_his_realtime_trans,
    connect_type
  } = data;

  return {
    is_cus_realtime_trans,
    is_cus_batch_trans,
    is_cus_connect,
    is_his_connect,
    is_his_realtime_trans,
    is_his_batch_trans,
    connect_type
  };
}
